import * as React from "react";

class Protected extends React.Component<any, any> {
  componentDidMount() {
    this.props.userLogin();
  }

  renderChildren() {
    return this.props.permit ? (
      { ...this.props.children }
    ) : (
      <div className="overlay" />
    );
  }

  render() {
    return <div className="protected">{this.renderChildren()}</div>;
  }
}

export default Protected;



// WEBPACK FOOTER //
// ./client/modules/User/components/Protected/component.tsx